export default __webpack_public_path__ + "static/media/lrm_export_10799813648159_20190626_2156584341048891702.a41ac019.jpeg";